import { Alert, AlertTitle, Stack, Typography } from "@mui/material";
import type { DwhSyncStartResult } from "./dwhSyncStartResult";

interface Props {
  results: DwhSyncStartResult[];
}

const statusLabels = {
  started: "Start request accepted",
  "already-running": "Sync already in progress; skipped",
  error: "Start request failed",
};

const statusSeverities = {
  started: "success",
  "already-running": "warning",
  error: "error",
} satisfies Record<DwhSyncStartResult["status"], "success" | "warning" | "error">;

const DwhSyncStartResults = ({ results }: Props) => {
  if (results.length === 0) {
    return null;
  }

  return (
    <Stack spacing={2} sx={{ width: "100%" }} aria-live="polite">
      <Typography variant="h6">Start results</Typography>
      {results.map((result) => (
        <Alert key={result.clientCode} severity={statusSeverities[result.status]}>
          <AlertTitle>
            {result.clientCode}: {statusLabels[result.status]}
          </AlertTitle>
          {result.correlationId && (
            <Typography sx={{ overflowWrap: "anywhere", userSelect: "all" }}>
              Correlation ID: {result.correlationId}
            </Typography>
          )}
          {result.errorMessage && <Typography>{result.errorMessage}</Typography>}
        </Alert>
      ))}
    </Stack>
  );
};

export default DwhSyncStartResults;
